module.exports = __webpack_public_path__ + "static/media/saco-lonesok_logotype.62c120b2.svg";